import {appHelper} from "../../utils/helpers/appHelper.js";
import auth from '../../middleware/auth.js';
import shortcuts from "../../middleware/shortcuts.js";
import {routeHelper} from "../../utils/helpers/routeHelper.js";

export const UserRouters = [
    {
        path: appHelper.path.home + '/user',
        name: 'myAccount',
        component: routeHelper.asyncComponentWithLoader(() => import('../../views/user/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.home + '/order',
        name: 'myOrder',
        component: routeHelper.asyncComponentWithLoader(() => import('../../modules/customer/views/order/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.home + '/invoice',
        name: 'myInvoice',
        component: routeHelper.asyncComponentWithLoader(() => import('../../modules/customer/views/invoice/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
]
